import { motion } from "framer-motion";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { useState } from "react";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    // TEMP: mock login → customer
    login("customer");
    navigate("/customer");
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-background px-4">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="
          w-full max-w-md
          bg-black/40 backdrop-blur
          border border-primary/30
          rounded-3xl shadow-2xl
          p-8
        "
      >
        <h2 className="text-3xl font-bold text-center mb-2">
          <span className="text-foreground">Welcome back</span>
        </h2>

        <p className="text-muted-foreground text-center mb-8">
          Login to continue
        </p>

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="text-sm text-muted-foreground">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="
                w-full mt-1 px-4 py-2
                rounded-xl bg-background
                border border-border
                focus:outline-none focus:ring-2 focus:ring-primary
              "
            />
          </div>

          <div>
            <label className="text-sm text-muted-foreground">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="
                w-full mt-1 px-4 py-2
                rounded-xl bg-background
                border border-border
                focus:outline-none focus:ring-2 focus:ring-primary
              "
            />
          </div>

          <button
            type="submit"
            className="
              w-full py-2 rounded-xl
              bg-primary text-primary-foreground
              font-semibold
              hover:opacity-90 transition
            "
          >
            Login
          </button>
        </form>

        <p className="text-sm text-center text-muted-foreground mt-6">
          Don’t have an account?{" "}
          <Link to="/signup" className="text-primary hover:underline">
            Sign up
          </Link>
        </p>
      </motion.div>
    </section>
  );
};

export default Login;
